import React from 'react';
import PropTypes from 'prop-types';

import { filterFunds } from '../../utils/fund-info';

const GqlWrapper = (props) => {
    const {
        client,
        loading,
        error,
        data: allData,
        dataFunc,
        filter,
        gqlFilter,
        placeholder,
        render,
        updateQuery
    } = props;

    const { children } = props;

    if (loading) {
        return typeof placeholder === 'function' ? props.placeholder() : null;
    }
    if (error && !props.data) {
        // to show error for other than 200 from graphql-batch - US81655
        if (typeof children === 'function') {
            return children({
                data: null,
                rawData: null,
                error: 'Something Went Wrong'
            });
        }
        return null;
    }

    let data = allData;
    let displayData = data;

    /** US87540 - Removing trpCode = 'ICM' from allMutualFunds query result  */
    if (data.allMutualFunds) {
        const allMutualFunds = filterFunds(data.allMutualFunds);
        displayData = {
            ...data,
            allMutualFunds
        };
        data = {
            ...data,
            allMutualFunds
        };
    }

    // Apply data manipulation function to data if it exists
    if (dataFunc) {
        displayData = dataFunc(data, filter, client, gqlFilter);
    }

    const result = {
        data: displayData,
        rawData: data
    };

    // use render prop if defined
    if (typeof render === 'function') {
        return render(displayData, data);
    }

    // if child is a function, pass data as function arg
    if (typeof children === 'function') {
        return children(result, updateQuery, client);
    }

    // otherwise implicitely inject data into children
    const childrenWithProps = React.Children.map(children, (child) =>
        React.cloneElement(child, result)
    );
    return <React.Fragment>{childrenWithProps}</React.Fragment>;
};

GqlWrapper.defaultProps = {
    filter: []
};

GqlWrapper.propTypes = {
    /**
     * Filter function for data
     */
    filter: PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.string, PropTypes.object])
    )
};

export default GqlWrapper;
